import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const JobCardSkeleton = () => {
  return (
    <div className="bg-white rounded-lg overflow-hidden border p-4 flex flex-col justify-between">
      <div className="flex flex-col mb-2 space-y-2">
        <div className="flex items-start justify-between">
          <div className="flex flex-row gap-3 mb-3">
            {/* <Skeleton circle width={40} height={40} /> */}
            <div className="flex flex-col items-start">
              <Skeleton width={150} height={20} />
              <Skeleton width={100} height={15} />
            </div>
          </div>
          <Skeleton width={30} height={30} />
        </div>
        {/* Méthode de travail et type de contrat */}
        <div className="flex gap-x-2">
          <Skeleton width={80} height={30} />
          <Skeleton width={80} height={30} />
        </div>
      </div>

      {/* Image et bas de la carte */}
      <div className="space-y-3">
        <Skeleton className="h-56 min-[1500px]:h-48 object-cover rounded-md w-full" />
        <div className="flex justify-between items-center text-sm gap-2">
          <Skeleton width={100} height={20} />
          <Skeleton width={80} height={20} />
        </div>
      </div>
    </div>
  );
};

export default JobCardSkeleton;
